import { IColumnsItem } from '@/components/custom-table/type.d';
import { IZoneAreaPageListItem } from '@/views/system-config/regional-setting/api/types';
import { filters, has } from '@/core/plugins/filter';

// 租户管理列表
export const renderColumns = (
  handleRegionalSetting: (regionId: string) => void,
  handleOperation: (customerId: string) => void,
  EDIT: string,
  VIEW_LOG: string,
): IColumnsItem<IZoneAreaPageListItem>[] => {
  return [
    {
      label: '区域名称',
      minWidth: '120',
      render: row => (
        <div>{row?.regionName}</div>
      ),
    },
    {
      label: '区域编码',
      minWidth: '120',
      render: row => (
        <div>{row?.regionCode}</div>
      ),
    },
    {
      label: '所属地区',
      width: '350',
      ellipsis: true,
      render: row => (
        <span>{row?.provinceAndCityInfo}</span>
      ),
    },
    {
      label: '创建人员',
      minWidth: '100',
      render: row => (
        <div>{row?.creatorName}</div>
      ),
    },
    {
      label: '创建时间',
      minWidth: '140',
      render: row => (
        <div>{filters.formatTime(row?.createdTime)}</div>
      ),
    },
    {
      label: '操作',
      minWidth: '150',
      fixed: 'right',
      render: row => (
        <div>
          {has(EDIT) && <el-button type="text" onClick={() => handleRegionalSetting(row?.regionId)}>编辑</el-button>}
          {has(VIEW_LOG) && <el-button type="text" onClick={() => handleOperation(row?.regionId)}>操作日志</el-button>}
        </div>
      ),
    },
  ];
};
